import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

interface Accommodation {
  id: number;
  name: string;
  type: string;
  location: string;
  distance: number;
  image: string;
  description: string;
  features: string[];
}

const mockAccommodations: Accommodation[] = [
  {
    id: 1,
    name: "Poplar Farm Leisure Park",
    type: "Touring Pitch",
    location: "Sutton On Sea, Lincolnshire",
    distance: 1,
    image: "https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/65fcbe180a9deeacc5eb9b2d505f7712.jpeg",
    description: "A relaxed countryside park with fishing, play areas and a café",
    features: ["Fishing Lakes", "Children's Play Area", "Café On Site", "Quiet Countryside Setting"]
  },
  {
    id: 2,
    name: "Wren Farm",
    type: "Touring Pitch",
    location: "Hogsthorpe, Lincolnshire",
    distance: 2,
    image: "https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/74097cca6510ae8d201393485d8d615a.jpeg",
    description: "A friendly family attraction with animals, outdoor space and activities for children",
    features: ["Farm Animals", "Play Areas", "Family Friendly", "Countryside Setting"]
  },
  {
    id: 3,
    name: "Cottage Farm Caravan Park",
    type: "Touring Pitch",
    location: "Addlethorpe, Lincolnshire",
    distance: 3,
    image: "https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/3f9259bcb69b3d099f268d265c51f883.jpeg",
    description: "A quiet countryside park for caravans and camping",
    features: ["Caravan & Camping Pitches", "Countryside Setting", "Family Friendly", "Peaceful Atmosphere"]
  },
  {
    id: 4,
    name: "Lakeside Camping & Fisheries",
    type: "Touring Pitch",
    location: "Saltfleet, Lincolnshire",
    distance: 4,
    image: "https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/ef2839277314273996625cceeac156e4.jpeg",
    description: "A scenic spot where visitors can camp and enjoy fishing by the water",
    features: ["Fishing Lakes", "Camping Areas", "Lakeside Views", "Relaxed Outdoor Setting"]
  },
  {
    id: 5,
    name: "Country Meadow Caravan Park",
    type: "Touring Pitch",
    location: "Sutton On Sea, Lincolnshire",
    distance: 5,
    image: "https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/4fa1ce05a402bac639ec5f8ddbff5f21.jpeg",
    description: "A small welcoming park set among open fields, ideal for a calm rural getaway",
    features: ["Large Open Pitches", "Wide Countryside Views", "Clean & Tidy Site", "Good For Quiet Walks"]
  },
  {
    id: 6,
    name: "The Hideaway Caravan",
    type: "Holiday Caravan",
    location: "Skegness, Lincolnshire",
    distance: 6,
    image: "https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/1d9800e2c2ec97000739ed9d196f67cd.jpeg",
    description: "A cosy private retreat designed for a quiet and relaxing escape",
    features: ["Private Secluded Setting", "Cosy Caravan Stay", "Peaceful & Quiet Location", "Ideal For Couples"]
  },
  {
    id: 7,
    name: "The Home Star",
    type: "Guest House",
    location: "Skegness, Lincolnshire",
    distance: 7,
    image: "https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/622ff67583f76ad8b4204b7101f0c0c5.jpeg",
    description: "A friendly seaside guest house offering comfortable rooms close to the beach and town centre",
    features: ["Close To Beach", "Near Town Centre", "Comfortable Guest Rooms", "Friendly Welcoming Stay"]
  },
  {
    id: 8,
    name: "The Singlecote",
    type: "Hotel",
    location: "Skegness, Lincolnshire",
    distance: 8,
    image: "https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/8a6708512bd6532abc2e0e2bda724710.jpeg",
    description: "A simple seaside hotel close to the beach and local attractions",
    features: ["Close To Beach", "Near Local Attractions", "Comfortable Rooms", "Seaside Location"]
  },
  {
    id: 9,
    name: "Beresford Cottage",
    type: "Holiday Let",
    location: "Skegness, Lincolnshire",
    distance: 9,
    image: "https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/93c97157c681fb6d1f07a803b5a7ad0d.jpeg",
    description: "A cosy self-catering holiday cottage close to the seaside and town centre",
    features: ["Home-Style Stay", "Self-Catering", "Ideal For Families", "Close To Attractions"]
  },
  {
    id: 10,
    name: "Ronam Cottage Caravan Park",
    type: "Touring Pitch",
    location: "Anderby Creek, Lincolnshire",
    distance: 10,
    image: "https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/325f0dc2f79c7955d9d78608748f46e0.jpeg",
    description: "A peaceful coastal park offering caravan stays close to the beach",
    features: ["Peaceful Caravan Site", "Seaside Setting", "Relaxed Site", "Close To Beach"]
  },
  {
    id: 11,
    name: "Galley Hill Farm Caravan & Camping",
    type: "Touring Pitch",
    location: "Alford, Lincolnshire",
    distance: 11,
    image: "https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/99e042cd6af5c786eed5b8d8f4948a4d.jpeg",
    description: "A quiet rural park offering caravan and camping stays in open farmland surroundings",
    features: ["Spacious Site", "Peaceful Surroundings", "Ideal For Relaxing", "Close To Alford"]
  },
  {
    id: 12,
    name: "Greenfield Caravan Park",
    type: "Holiday Caravan",
    location: "Trusthorpe, Lincolnshire",
    distance: 12,
    image: "https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/c1cf4c95f46da44688ab9553cc8c2210.jpeg",
    description: "A relaxing spot by the sea and ideal for a holiday close to the shoreline",
    features: ["Holiday Caravans", "Beach Access", "On-Site Shop", "Family-Run Park"]
  },
  {
    id: 13,
    name: "Sutton Springs Holiday Estate",
    type: "Holiday Caravan",
    location: "Trusthorpe, Lincolnshire",
    distance: 13,
    image: "https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/f496fe20f8d69215bbeeef0be9bbe35a.jpeg",
    description: "Relaxing beachfront retreat set along the quiet Lincolnshire coast",
    features: ["Beachfront Location", "Static Caravans", "Pool & Play Areas", "Family-Friendly Park"]
  },
  {
    id: 14,
    name: "Trusthorpe Springs Holiday Park",
    type: "Holiday Caravan",
    location: "Trusthorpe, Lincolnshire",
    distance: 14,
    image: "https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/52a0edd34c21b4b0147cf95f67dd9f00.jpeg",
    description: "A peaceful family-friendly holiday park just a short distance from the coast",
    features: ["Outdoor Pool", "Touring & Camping Pitches", "On-Site Bar", "Play Area"]
  },
  {
    id: 15,
    name: "Anderby Springs Holiday Park",
    type: "Holiday Caravan",
    location: "Anderby Creek, Lincolnshire",
    distance: 15,
    image: "https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/e52bc021f31111af486135457654d74d.jpeg",
    description: "Quiet coastal getaway just a short walk from Anderby Creek's unspoilt beach",
    features: ["Near The Coast", "Calm Atmosphere", "Peaceful Seaside Stay", "Natural Surroundings"]
  },
  {
    id: 16,
    name: "Lakeside Springs Caravan Park & Touring Site & Fishing Lake",
    type: "Holiday Caravan",
    location: "Sutton On Sea, Lincolnshire",
    distance: 16,
    image: "https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/6aac8d3a7cd05c75e7d943ce8bbde078.jpeg",
    description: "A quiet park with caravan touring and an on-site fishing lake",
    features: ["Fishing Lake", "Open Setting", "Family-Friendly", "Suitable For Touring"]
  },
  {
    id: 17,
    name: "Cherry Tree Springs Touring Park",
    type: "Touring Pitch",
    location: "Sutton On Sea, Lincolnshire",
    distance: 17,
    image: "https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/e9a1c9dcc1daadb5ce34fcfcf26d3a23.jpeg",
    description: "A countryside site for touring caravans and motorhomes",
    features: ["Touring Pitches", "Well-Kept Grounds", "Rural Location", "Ideal For Relaxing"]
  },
  {
    id: 18,
    name: "Meadow Lakes Caravan Hire",
    type: "Holiday Caravan",
    location: "Ingoldmells, Lincolnshire",
    distance: 18,
    image: "https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/dfefccfa706b24680d72358f7bd38bb6.jpeg",
    description: "Provides self-catering holiday caravans to rent along the Lincolnshire coast",
    features: ["Caravans & Hot Tub Lodges", "Large Selection", "Varying Locations", "Self-Catering"]
  }
];

export default function AccommodationPage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [selectedType, setSelectedType] = useState('All');
  const [searchLocation, setSearchLocation] = useState('');
  const [radius, setRadius] = useState('');
  const [filteredAccommodations, setFilteredAccommodations] = useState(mockAccommodations);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;

  const typeColors: { [key: string]: string } = {
    'Touring Pitch': 'bg-cyan-100 text-cyan-700',
    'Holiday Caravan': 'bg-cyan-100 text-cyan-700',
    'Campsite': 'bg-cyan-100 text-cyan-700',
    'Guest House': 'bg-cyan-100 text-cyan-700',
    'Hotel': 'bg-cyan-100 text-cyan-700',
    'Lodge': 'bg-cyan-100 text-cyan-700',
  };

  const featureColors = [
    'bg-orange-100 text-orange-700',
    'bg-teal-100 text-teal-700',
    'bg-green-100 text-green-700',
    'bg-pink-100 text-pink-700',
    'bg-cyan-100 text-cyan-700',
    'bg-amber-100 text-amber-700',
    'bg-emerald-100 text-emerald-700',
    'bg-lime-100 text-lime-700'
  ];

  const getFeatureColor = (index: number) => {
    return featureColors[index % featureColors.length];
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    let filtered = mockAccommodations;

    if (selectedType !== 'All') {
      filtered = filtered.filter(acc => acc.type === selectedType);
    }

    if (searchLocation.trim()) {
      filtered = filtered.filter(acc => 
        acc.location.toLowerCase().includes(searchLocation.toLowerCase())
      );
    }

    if (radius) {
      const maxDistance = parseInt(radius);
      filtered = filtered.filter(acc => acc.distance <= maxDistance);
    }

    setFilteredAccommodations(filtered);
    setCurrentPage(1);
  }, [selectedType, searchLocation, radius]);

  // Scroll to top when page changes
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [currentPage]);

  const handleReset = () => {
    setSelectedType('All');
    setSearchLocation('');
    setRadius('');
  };

  const handleViewOnApp = () => {
    const downloadSection = document.getElementById('download-app-section');
    if (downloadSection) {
      downloadSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  const totalPages = Math.ceil(filteredAccommodations.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentAccommodations = filteredAccommodations.slice(startIndex, endIndex);

  const getPageNumbers = () => {
    const pages = [];
    const maxPagesToShow = 5;
    
    if (totalPages <= maxPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 4; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1);
        pages.push('...');
        for (let i = totalPages - 3; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);
        pages.push('...');
        pages.push(currentPage - 1);
        pages.push(currentPage);
        pages.push(currentPage + 1);
        pages.push('...');
        pages.push(totalPages);
      }
    }
    
    return pages;
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-white shadow-md'}`}>
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3 transform transition-transform duration-300 hover:scale-105">
              <img 
                src="https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/659671df2896ffc0ce475e0437197503.png" 
                alt="Seaside Vouchers Logo" 
                className="h-16 w-16 object-contain"
              />
            </Link>
            <div className="hidden md:flex items-center gap-8">
              <Link to="/" className="text-sm font-semibold text-gray-900 hover:text-orange-500 transition-all duration-300 whitespace-nowrap relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-orange-500 after:transition-all after:duration-300 hover:after:w-full">Home</Link>
              <Link to="/how-it-works" className="text-sm font-semibold text-gray-900 hover:text-orange-500 transition-all duration-300 whitespace-nowrap relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-orange-500 after:transition-all after:duration-300 hover:after:w-full">How it works</Link>
              <Link to="/seaside-offers" className="text-sm font-semibold text-gray-900 hover:text-orange-500 transition-all duration-300 whitespace-nowrap relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-orange-500 after:transition-all after:duration-300 hover:after:w-full">Seaside Vouchers App</Link>
              <Link to="/voucher-book" className="text-sm font-semibold text-gray-900 hover:text-orange-500 transition-all duration-300 whitespace-nowrap relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-orange-500 after:transition-all after:duration-300 hover:after:w-full">Voucher Book</Link>
              <Link to="/leisure-home-sales" className="text-sm font-semibold text-gray-900 hover:text-orange-500 transition-all duration-300 whitespace-nowrap relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-orange-500 after:transition-all after:duration-300 hover:after:w-full">Leisure Home Sales</Link>
              <Link to="/accommodation" className="text-sm font-semibold text-gray-900 hover:text-orange-500 transition-all duration-300 whitespace-nowrap relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-orange-500 after:transition-all after:duration-300 hover:after:w-full">Accommodation</Link>
              <Link to="/contact" className="text-sm font-semibold text-gray-900 hover:text-orange-500 transition-all duration-300 whitespace-nowrap relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-orange-500 after:transition-all after:duration-300 hover:after:w-full">Contact us</Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative pt-28 pb-8 bg-gradient-to-br from-teal-400 to-teal-500 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute top-10 left-10 w-64 h-64 bg-cyan-300 rounded-full opacity-20 blur-3xl animate-pulse"></div>
          <div className="absolute bottom-10 right-20 w-80 h-80 bg-blue-300 rounded-full opacity-20 blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
          <div className="absolute top-1/2 left-1/3 w-48 h-48 bg-white rounded-full opacity-10 blur-2xl animate-pulse" style={{ animationDelay: '2s' }}></div>
        </div>

        <div className="container mx-auto px-6 relative z-10">
          <div className="text-center text-white mb-6">
            <h1 className="text-5xl font-bold mb-3 drop-shadow-lg">Accommodation</h1>
            <p className="text-xl max-w-3xl mx-auto drop-shadow-md mb-2">Find the perfect place to stay on the Lincolnshire Coast</p>
            <p className="text-lg max-w-3xl mx-auto drop-shadow-md">From Campsites to Hotels, discover great seaside places to stay - and book direct to support local businesses and get the best value!</p>
          </div>
        </div>
      </section>

      {/* Info Section */}
      <section className="py-8 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto bg-gradient-to-br from-teal-400 to-teal-500 rounded-xl p-8">
            <p className="text-white text-lg leading-relaxed drop-shadow-md">
              Seaside Vouchers showcases local accommodation without taking commission. Book direct through our app, deal directly with the accommodation, and know that 100% of your booking supports local seaside businesses — not big booking platforms.
            </p>
          </div>
        </div>
      </section>

      {/* Search and Filter Section */}
      <section className="py-8 bg-white border-b border-gray-200">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Accommodation Type</label>
              <select
                value={selectedType}
                onChange={(e) => setSelectedType(e.target.value)}
                className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent cursor-pointer"
              >
                <option value="All">All Types</option>
                <option value="Touring Pitch">Touring Pitch</option>
                <option value="Holiday Caravan">Holiday Caravan</option>
                <option value="Campsite">Campsite</option>
                <option value="Guest House">Guest House</option>
                <option value="Hotel">Hotel</option>
                <option value="Lodge">Lodge</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Location</label>
              <div className="relative">
                <i className="ri-map-pin-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-lg"></i>
                <input
                  type="text"
                  placeholder="Search location..."
                  value={searchLocation}
                  onChange={(e) => setSearchLocation(e.target.value)}
                  className="w-full pl-12 pr-4 py-3 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Distance (miles)</label>
              <select
                value={radius}
                onChange={(e) => setRadius(e.target.value)}
                className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent cursor-pointer"
              >
                <option value="">Any Distance</option>
                <option value="5">Within 5 miles</option>
                <option value="10">Within 10 miles</option>
                <option value="15">Within 15 miles</option>
                <option value="20">Within 20 miles</option>
              </select>
            </div>
          </div>

          <div className="flex justify-center">
            <button
              onClick={handleReset}
              className="px-6 py-2 bg-gray-100 text-gray-700 rounded-lg font-medium text-sm hover:bg-gray-200 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-refresh-line mr-2"></i>Reset Filters
            </button>
          </div>
        </div>
      </section>

      {/* Accommodation Listings */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {currentAccommodations.map((accommodation) => {
              return (
                <div key={accommodation.id} className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-shadow flex flex-col">
                  <div className="h-56 w-full overflow-hidden relative group">
                    <img 
                      src={accommodation.image} 
                      alt={accommodation.name} 
                      className="w-full h-full object-cover object-center"
                    />
                  </div>
                  
                  <div className="p-6 flex flex-col flex-grow">
                    <div className="flex items-center justify-between mb-2">
                      <span className={`inline-block px-3 py-1 text-xs font-semibold rounded-full ${typeColors[accommodation.type] || 'bg-gray-100 text-gray-700'}`}>
                        {accommodation.type}
                      </span>
                    </div>
                    
                    <h3 className="text-xl font-bold text-gray-900 mb-2">{accommodation.name}</h3>
                    <p className="text-sm text-gray-600 mb-1">
                      <i className="ri-map-pin-2-fill text-orange-500"></i> {accommodation.location}
                    </p>
                    <p className="text-sm text-gray-700 mb-4">{accommodation.description}</p>
                    
                    <div className="flex flex-wrap gap-2 mb-4">
                      {accommodation.features.map((feature, index) => (
                        <span key={index} className={`text-xs px-2 py-1 rounded font-medium ${getFeatureColor(index)}`}>
                          {feature}
                        </span>
                      ))}
                    </div>
                    
                    <button 
                      onClick={handleViewOnApp}
                      className="w-full bg-orange-500 text-white py-3 rounded-lg font-semibold hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer mt-auto"
                    >
                      MORE INFO
                    </button>
                  </div>
                </div>
              );
            })}
          </div>

          {filteredAccommodations.length === 0 && (
            <div className="text-center py-16">
              <i className="ri-home-smile-line text-6xl text-gray-300 mb-4"></i>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">No accommodation found</h3>
              <p className="text-gray-600 mb-6">Try adjusting your search filters</p>
              <button
                onClick={handleReset}
                className="px-8 py-3 bg-cyan-500 text-white rounded-lg font-semibold hover:bg-cyan-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Reset Filters
              </button>
            </div>
          )}

          {filteredAccommodations.length > 0 && totalPages > 1 && (
            <div className="flex items-center justify-center gap-2 mt-12">
              <button
                onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                disabled={currentPage === 1}
                className={`px-4 py-2 rounded-lg font-medium text-sm transition-all whitespace-nowrap cursor-pointer ${
                  currentPage === 1
                    ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                    : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
                }`}
              >
                <i className="ri-arrow-left-s-line"></i> Back
              </button>

              <div className="flex items-center gap-2">
                {getPageNumbers().map((page, index) => (
                  <button
                    key={index}
                    onClick={() => typeof page === 'number' && setCurrentPage(page)}
                    disabled={page === '...'}
                    className={`min-w-[40px] h-10 rounded-lg font-medium text-sm transition-all whitespace-nowrap ${
                      page === currentPage
                        ? 'bg-orange-500 text-white shadow-md cursor-pointer'
                        : page === '...'
                        ? 'bg-transparent text-gray-400 cursor-default'
                        : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50 cursor-pointer'
                    }`}
                  >
                    {page}
                  </button>
                ))}
              </div>

              <button
                onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                disabled={currentPage === totalPages}
                className={`px-4 py-2 rounded-lg font-medium text-sm transition-all whitespace-nowrap cursor-pointer ${
                  currentPage === totalPages
                    ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                    : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
                }`}
              >
                Next <i className="ri-arrow-right-s-line"></i>
              </button>

              <button
                onClick={() => setCurrentPage(totalPages)}
                disabled={currentPage === totalPages}
                className={`px-4 py-2 rounded-lg font-medium text-sm transition-all whitespace-nowrap cursor-pointer ${
                  currentPage === totalPages
                    ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                    : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
                }`}
              >
                End <i className="ri-skip-right-line"></i>
              </button>
            </div>
          )}
        </div>
      </section>

      {/* Download App CTA */}
      <section id="download-app-section" className="py-16 bg-gradient-to-br from-blue-500 to-blue-600">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">Book Your Stay on the App</h2>
          <p className="text-xl text-white mb-8 max-w-2xl mx-auto">
            Download the Seaside Vouchers app to view full details, contact accommodation providers directly, and book your perfect seaside stay
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href="https://apps.apple.com/pk/app/seaside-vouchers-user/id6745555629" target="_blank" rel="noopener noreferrer" className="cursor-pointer">
              <img 
                src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1726012800" 
                alt="Download on App Store" 
                className="h-14"
              />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.jeuxdevelopers.SeasideUser&pcampaignid=web_share&pli=1" target="_blank" rel="noopener noreferrer" className="cursor-pointer">
              <img 
                src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png" 
                alt="Get it on Google Play" 
                className="h-14"
              />
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-cyan-500 text-white py-8">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-6">
            <div>
              <img 
                src="https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/659671df2896ffc0ce475e0437197503.png" 
                alt="Seaside Vouchers" 
                className="h-20 w-20 object-contain"
              />
            </div>

            <div>
              <h4 className="font-bold text-lg mb-4">Quick Link</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Home</Link></li>
                <li><Link to="/how-it-works" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">How it works</Link></li>
                <li><Link to="/seaside-offers" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Seaside offers</Link></li>
                <li><Link to="/voucher-book" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Voucher Book</Link></li>
                <li><Link to="/leisure-home-sales" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Leisure Home Sales</Link></li>
                <li><Link to="/accommodation" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Accommodation</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold text-lg mb-4">Company</h4>
              <ul className="space-y-2 text-sm">
                <li><a href="https://seasidevouchers.co.uk/privacy-policy/" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Privacy &amp; cookie policy</a></li>
                <li><a href="https://seasidevouchers.co.uk/terms-conditions/" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">T&amp;C</a></li>
                <li><Link to="/contact" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Contact us</Link></li>
                <li><Link to="/business-registration" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Add Your Business</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold text-lg mb-4">Follow Us</h4>
              <div className="flex gap-4">
                <a href="https://www.facebook.com/people/seasidevouchers/61566031950810/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full hover:bg-white/30 transition-all duration-300 cursor-pointer transform hover:scale-110 hover:-translate-y-1">
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a href="https://www.instagram.com/seaside_vouchers/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full hover:bg-white/30 transition-all duration-300 cursor-pointer transform hover:scale-110 hover:-translate-y-1">
                  <i className="ri-instagram-line text-xl"></i>
                </a>
                <a href="https://www.tiktok.com/@seasidevouchers" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full hover:bg-white/30 transition-all duration-300 cursor-pointer transform hover:scale-110 hover:-translate-y-1">
                  <i className="ri-tiktok-fill text-xl"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-white/20 pt-4 text-center text-sm">
            <p>Copyright © 2023 Seaside Voucher, All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
